<template>
  <v-card class="mt-8">
    <v-card-text>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        :outlined="true"
        dense
        clearable
      ></v-text-field>
      <v-data-table
        dense
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="users"
        :single-select="false"
        show-select
        item-key="_id"
        :server-items-length="serverItemsLength"
        :search="search"
        :options.sync="options"
        @update:page="handlePage"
        @update:items-per-page="handleItemsPerPage"
        @update:sort-by="handleSortBy"
        @update:sort-desc="handleSortDesc"
        :footer-props="{ 'items-per-page-options': [10, 15, 20, 25] }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Manage Users</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <div v-if="selected.length">
              <v-btn @click="deleteSelected" color="red" small text
                >Delete</v-btn
              ><v-btn text small color="primary">Make Scrutineer</v-btn>
            </div>
            <v-spacer></v-spacer>

            <AddEditUser
              :dialog="dialog"
              @dialog="dialog = $event"
              :user="user"
              @update="[rebuildTable(), (user = $event)]"
            />
            <ImportUsers />
            <v-btn
              class="mb-2 ml-2"
              @click="handleExportUsers"
              color="primary"
              small
              >Export</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:item.tags="{ item }">
          <v-chip
            x-small
            class="mr-1"
            v-for="tag in item.tags"
            v-bind:key="tag"
            >{{ tag }}</v-chip
          >
        </template>
        <template v-slot:item.actions="{ item }">
          <GenerateUrl :user="item" />
          <v-icon small class="mr-2" @click="editUser(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteUser(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.lastName="{ item }">
          {{ item.firstName }} {{ item.lastName }}
        </template>
        <template v-slot:item.token="{ item }">
          <a
            target="_Blank"
            :href="`/live/${$store.state.events.event._id}/${item.token}`"
            >{{ item.token }}</a
          >
        </template>

        <template v-slot:item.scrutineer="{ item }">
          <span v-if="item.scrutineer">
            Yes
          </span>
        </template>
        <template v-slot:item.lastAccess="{ item }">
          <span>{{ item.lastAccess }}</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import api from "@/services/api";
import AddEditUser from "@/components/Admin/Forms/AddEditUser";
import ImportUsers from "@/components/Admin/DataTables/ImportUsers";
import GenerateUrl from "@/components/Admin/DataTables/GenerateUrl";
import { mapState } from "vuex";
export default {
  components: {
    AddEditUser,
    ImportUsers,
    GenerateUrl
  },
  data() {
    return {
      loading: false,
      search: "",
      dialog: false,
      selected: [],
      headers: [
        { value: "lastName", text: "Name" },
        { value: "firstName", text: "First Name", align: " d-none" },
        { value: "lastName", text: "Last Name", align: " d-none" },
        //{ value: "token", text: "Secure Token" },
        { value: "weightedProxy", text: "Proxies", align: "center" },
        { value: "scrutineer", text: "Scrutineer", align: "center" },

        { value: "lastAccess", text: "Last access" },
        { value: "role", text: "Role" },
        { value: "tags", text: "Tags" },
        { value: "actions", text: "Actions", sortable: false }
      ],

      users: [],
      user: {},

      serverItemsLength: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
        sortBy: ["lastName"],
        sortDesc: [false],
        multiSort: false
      }
    };
  },
  computed: {
    ...mapState({
      event: (state) => state.events.event
    })
  },
  watch: {
    search(val) {
      this.search = val;
      this.rebuildTable();
    }
  },

  async created() {
    this.rebuildTable();
  },
  methods: {
    async rebuildTable() {
      this.loading = true;
      this.users = await api.getUsers(this.event._id, {
        search: this.search,
        limit: this.options.itemsPerPage > 0 ? this.options.itemsPerPage : 0,
        page: this.options.page,
        sort: this.options.sortBy[0],
        direction: this.options.sortDesc[0] ? -1 : 1 // -1 = descending
      });

      this.serverItemsLength = await api.getUserCount(
        this.event._id,
        this.search
      );
      this.loading = false;

      //console.log(this.pagination.itemsLength)
    },
    async editUser(item) {
      this.dialog = true;
      this.user = await api.getUser(item._id);
      if (this.user.proxy) this.user.proxy = this.user.proxy._id;
    },
    async deleteUser(user) {
      if (confirm("Are you sure you want to delete this user?")) {
        await api.deleteUser(user);
        this.rebuildTable();
      }
    },
    async deleteSelected() {
      let ids = this.selected.map((user) => user._id);
      if (confirm("Are you sure you want to delete selected users?")) {
        await api.deleteUserByIds(ids);
        this.rebuildTable();
        this.selected = [];
      }
    },
    async handlePage(page) {
      this.options.page = page;
      this.rebuildTable();
    },
    async handleItemsPerPage(itemsPerPage) {
      this.options.itemsPerPage = itemsPerPage;
      this.rebuildTable();
    },
    async handleSortBy(field) {
      this.options.sortBy = field;
      this.rebuildTable();
    },
    async handleSortDesc(field) {
      this.options.sortDesc = field;
      this.rebuildTable();
    },
    async handleExportUsers() {
      try {
        await api.exportUsers(this.event._id);
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
